import { QGetCategories } from "./QGetCategories";
import { QGetFreespins } from "./QGetFreespins";
import { QGetGames } from "./QGetGames";
import { QGetLaunchParams } from "./QGetLaunchParams";
export const QueryBuilder = {
    getCategories: QGetCategories,
    getFreespins: QGetFreespins,
    getGames: QGetGames,
    getLaunchParams: QGetLaunchParams
};
//# sourceMappingURL=index.js.map